// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2lUd31sLtknp","slide":"rX0uJt4uB3gZ","item":"_1TFivAlpCqHz _3UEdIFWjSnQz","item__head":"_2xEmAxfuVW_w _24_TznBsQv6d","item__middle":"KHdCVG14Bhla I-iacZ2404vS"};